import React from "react";
import { Controller } from "react-hook-form";
import { formatCurrency as utilFormatCurrency } from "../../../../utils/format";

export default function ControlledField({
  name,
  control,
  InputComponent,
  label,
  placeholder,
  type = "text",
  cleanNumber,
  handleCurrencyBlur,
  onFormatted,
  handleCalAmount,
  defaultValue = "",
  value: valueProp,
  // Day-count fields (e.g. "Days") shouldn't display/commit with currency-
  // style ".00" decimals — pass decimals={0} to format them as plain whole
  // numbers. Left undefined, both the visual input and the blur-commit
  // below fall back to the existing 2-decimal currency formatting.
  decimals,
  inputProps = {},
}) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <InputComponent
          {...field}
          placeholder={placeholder}
          label={label}
          type={type}
          decimals={decimals}
          value={
            valueProp !== undefined ? valueProp : (field.value ?? defaultValue)
          }
          {...inputProps}
          onChange={(e) => {
            const raw = e?.target?.value ?? "";
            const cleaned = cleanNumber ? cleanNumber(raw) : raw;
            field.onChange(cleaned);
          }}
          onBlur={(e) => {
            field.onBlur?.(e);
            const rawValue = e?.target?.value ?? field.value ?? "";
            const cleaned = cleanNumber
              ? cleanNumber(String(rawValue))
              : String(rawValue).replace(/[^0-9.]/g, "");
            if (cleaned === "") return;

            const formatted = utilFormatCurrency(cleaned, { decimals });

            if (formatted !== field.value) {
              field.onChange(formatted);
              onFormatted?.(name, formatted);
            }
          }}
        />
      )}
    />
  );
}
